import {
	type ListNetworkNodesParams,
	type Network,
	type NetworkConnection,
	type NetworkNode,
	useListNetworkConnectionsSuspense,
	useListNetworkNodesSuspense,
} from '@amarantos/api-client'

import { useWholeListTruncationWarning } from '@/hooks/use-whole-list-truncation-warning'
import { WHOLE_LIST_PER_PAGE } from '@/utils/whole-list'

// The canvas lays out a whole network at once, so elements come on one large page; the params
// shape is shared by the node and connection endpoints.
export function toListNetworkElementsParams(): ListNetworkNodesParams {
	return {
		page: 1,
		per_page: WHOLE_LIST_PER_PAGE,
	}
}

/** The selected network's whole plan, fetched with Suspense — shared by both fullscreen editor views;
 *  the route's loader pre-caches the same queries via `toListNetworkElementsParams`. */
export function useNetworkElements(networkId: Network['id']): {
	nodes: NetworkNode[]
	connections: NetworkConnection[]
} {
	const params = toListNetworkElementsParams()
	const nodesPage = useListNetworkNodesSuspense(networkId, params).data
	const connectionsPage = useListNetworkConnectionsSuspense(networkId, params).data
	useWholeListTruncationWarning('nodes', nodesPage)
	useWholeListTruncationWarning('connections', connectionsPage)

	return { nodes: nodesPage.data, connections: connectionsPage.data }
}
